module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-2.1dad4dd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-2.png
// module id = 1284
// module chunks = 1